import React from 'react';
import { useTranslation } from 'react-i18next';

import MathEnglishBanner from '@/components/MathEnglishBanner';

function Banner() {
  const { t } = useTranslation(['home', 'english', 'path']);
  return (
    <MathEnglishBanner
      title={t('english:banner-主标题')}
      subTitle={t('english:banner-副标题')}
      age="3-6 年级"
      tp={t('english:评分')}
      subject="english"
      btnName={t('english:banner-按钮')}
      useTranslationName="english"
      ga="O_EnglishCourse_FirstModule_CTAClick"
      ga4="new_entry_EnglishCourse_FirstModuleCTA"
      alt="seo-英文-student-banner"
    />
  );
}

export default Banner;
